// Número do WhatsApp da imobiliária (configurável)
export const WHATSAPP_NUMBER = '5579999881002'; // Formato: código do país + DDD + número

export function createWhatsAppLink(message: string): string {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
}

export function createPropertyWhatsAppMessage(propertyTitle: string, propertyCode: string): string {
  return `Olá! Tenho interesse no imóvel ${propertyTitle} (Código: ${propertyCode}). Gostaria de mais informações.`;
}

/**
 * Envia mensagem via WhatsApp
 * Abre o WhatsApp Web/App com a mensagem pré-preenchida
 */
export async function sendWhatsAppMessage(phoneNumber: string, message: string): Promise<void> {
  // Limpa o número de telefone (remove espaços, parênteses, hífens)
  const cleanPhone = phoneNumber.replace(/\D/g, '');
  
  // Adiciona código do país se não tiver
  const fullPhone = cleanPhone.startsWith('55') ? cleanPhone : `55${cleanPhone}`;
  
  // Codifica a mensagem
  const encodedMessage = encodeURIComponent(message);
  
  // Cria o link do WhatsApp
  const whatsappUrl = `https://wa.me/${fullPhone}?text=${encodedMessage}`;
  
  // Abre em nova aba
  window.open(whatsappUrl, '_blank');
}
